import http from '@/utils/http'
import service from '@/http/service'

export default {
  url: `${service.sys}/information`,
  getListByPage(params) {
    return http.get(`${this.url}/queryList`, params)
  },
  getInfoById(id) {
    return http.get(`${this.url}/info/${id}`)
  }
}